"use strict";

import React from 'react';
import defaultState from '../store/account-echeck-initial-state';
import { AccountEcheckProvider as Provider } from "../context/AccountEcheckContext";
import axios from "../utilities/axiosEcheckWrapper";
import objectPath from 'object-path';
import {withAlert} from "react-alert";

class AccountEcheckProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = defaultState;
        const cancelToken = axios.CancelToken;
        this.axiosCancelSource = cancelToken.source();
        this.fetchAccountsEchecks = this.fetchAccountsEchecks.bind(this);
        this.setEchecks = this.setEchecks.bind(this);
        this.revokeEcheck = this.revokeEcheck.bind(this);
    }

    componentDidMount() {
        this.fetchAccountsEchecks();
    }

    componentWillUnmount(){
        this.axiosCancelSource.cancel();
    }

    fetchAccountsEchecks(){
        this.setState(()=>{
            return {isFetchingEchecks: true};
        });
        axios.get(`echecks/accounts/echecks`)
            .then((response)=>{
                this.setEchecks(response.data);
            })
            .catch((error)=>{
                return false;
            }).finally(()=>{
            this.setState(()=>{
                return {isFetchingEchecks: false};
            });
        });
    }

    setEchecks(echecks={}){
        this.setState(()=>{
            return {echecks: [...echecks]};
        })
    }

    revokeEcheck( echeck={} ){
        const id = echeck.authorization_id || '';
        if(!!id){
            axios.delete(`echecks/accounts/echecks/${id}`)
                .then((response)=>{
                    this.props.alert.success(`Echeck: ${id} has been revoked.`);
                    this.fetchAccountsEchecks();
                })
                .catch((error)=>{
                    return false;
                });
        }
    }

    render() {
        return (
            <Provider value={{
                ...this.state,
                revokeEcheck: this.revokeEcheck,
            }}> {this.props.children}</Provider>);
    }
}

export default withAlert()(AccountEcheckProvider);
